@if (companies().length >= 1) {
  <div class="kr-company-selector surface">
    <kr-search-select
      class="kr-company-selector__select"
      data-testid="company_selector"
      [control]="companyNameControl"
      [items]="companies()"
      [withSearch]="false"
      [multi]="false"
      [isReadonly]="companies().length === 1"
      [label]="'shell.header.company.current' | translate">
      <ng-template #itemTpl let-item>
        <div class="select-item-custom">
          <span class="select-item-custom__name" [title]="item.name || item">{{
            item.name || item
          }}</span>
          <span class="select-item-custom__providers">
            @if (item.providers?.length) {
              @for (provider of item.providers; track provider.id) {
                <kr-provider-icon
                  [providerType]="provider.type"
                  [attr.data-testid]="'provider_icon_' + provider.id" />
              }
            }
          </span>
        </div>
      </ng-template>
    </kr-search-select>
  </div>
}
